// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// // import { useAuth } from '../../contexts/AuthContext';
// import VideoPlayer from '../../components/learning/VideoPlayer';
// import ModuleList from '../../components/learning/ModuleList';
// import ProgressTracker from '../../components/learning/ProgressTracker';
// import Notes from '../../components/learning/Notes';
// import '../../assets/css/pages/learning.css';

// const courseData = {
//     title: "Best Management Practices in Aquaculture",
//     description: "Master the essential practices for successful aquaculture management",
//     duration: "1 min",
//     modules: [
//         {
//             id: 1,
//             title: "Introduction to Aquaculture Management",
//             sessions: [
//                 {
//                     id: "1.1",
//                     title: "Overview of Aquaculture Systems",
//                     duration: "45 mins",
//                     videoUrl: "https://www.youtube.com/watch?v=apqXWvaGmow",
//                     notes: "c:/Users/ARENA/Downloads/2025-01-22 Info Pack for participants.pdf",
//                     isCompleted: false
//                 },
//                 // More sessions...
//             ]
//         },
//         // More modules...
//     ]
// };

// const LearningPage = () => {
//     const [currentModule, setCurrentModule] = useState(0);
//     const [currentSession, setCurrentSession] = useState(0);
//     const [progress, setProgress] = useState(0);
//     // const { user, isSubscribed } = useAuth();
//     const navigate = useNavigate();

//     // useEffect(() => {
//     //     if (!user) {
//     //         navigate('/login');
//     //         return;
//     //     }
//     //     if (!isSubscribed) {
//     //         navigate('/pricing');
//     //         return;
//     //     }
//     // }, [user, isSubscribed]);

//     const handleSessionComplete = (moduleId, sessionId) => {
//         // Update progress
//         // Check if eligible for certificate
//         const currentModuleData = courseData.modules[moduleId];
//         const totalSessions = currentModuleData.sessions.length;
//         const updatedSessions = [...currentModuleData.sessions];
//         updatedSessions[sessionId].isCompleted = true;

//         const completedSessions = updatedSessions.filter(session => session.isCompleted).length;
//         const newProgress = Math.round((completedSessions / totalSessions) * 100);

//         setProgress(newProgress);

//         if (newProgress === 100) {
//             navigate('/certificate');
//         }
//     };

//     return (
//         <div className="learning-page">
//             <div className="course-hero">
//                 <h1>{courseData.title}</h1>
//                 <p>{courseData.description}</p>
//                 <ProgressTracker 
//                     progress={progress} 
//                     totalDuration={courseData.duration} 
//                 />
//             </div>

//             <div className="learning-container">
//                 <aside className="module-sidebar">
//                     <ModuleList 
//                         modules={courseData.modules}
//                         currentModule={currentModule}
//                         currentSession={currentSession}
//                         onSessionSelect={(moduleId, sessionId) => {
//                             if (moduleId <= currentModule) {
//                                 setCurrentModule(moduleId);
//                                 setCurrentSession(sessionId);
//                             }
//                         }}
//                     />
//                 </aside>

//                 <main className="learning-content">
//                     <VideoPlayer 
//                         // url={courseData.modules[currentModule].sessions[currentSession].videoUrl}
//                         url="https://www.youtube.com/watch?v=apqXWvaGmow"
//                         onComplete={() => handleSessionComplete(currentModule, currentSession)}
//                     />
//                     <Notes 
//                         content={courseData.modules[currentModule].sessions[currentSession].notes}
//                     />
//                 </main>
//             </div>
//         </div>
//     );
// };

// export default LearningPage;

import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import VideoPlayer from '../../components/learning/VideoPlayer';
import ModuleList from '../../components/learning/ModuleList';
import ProgressTracker from '../../components/learning/ProgressTracker';
import Notes from '../../components/learning/Notes';
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import { courseApi } from '../../network/apis/course';
import '../../assets/css/pages/course.css';
import { showError, showSuccess } from '../../components/elements/customError';

const CoursePage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    
    // const [courseData, setCourseData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error,] = useState(null);
    const [currentModule, setCurrentModule] = useState(0);
    const [currentSession, setCurrentSession] = useState(0);
    const [progress, setProgress] = useState(0);
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [completedModules, setCompletedModules] = useState(new Set());
    const [completedSessions, setCompletedSessions] = useState(new Set());

    const markModuleComplete = (moduleId) => {
        const newCompletedModules = new Set(completedModules);
        newCompletedModules.add(moduleId);
        setCompletedModules(newCompletedModules);

        // Calculate overall progress
        const totalModules = courseData.modules.length;
        const newProgress = Math.round((newCompletedModules.size / totalModules) * 100);
        setProgress(newProgress);

        // Check if this was the last module
        if (newCompletedModules.size === totalModules) {
            showSuccess('Congratulations! You\'ve completed the course!');
            navigate('/certificate');
            return;
        }

        // Move to next module
        if (moduleId < courseData.modules.length - 1) {
            setCurrentModule(moduleId + 1);
            setCurrentSession(0);
        }
    };

    const handleSessionComplete = async (moduleId, sessionId) => {
        try {
            // Mark session as completed
            const newCompletedSessions = new Set(completedSessions);
            const sessionKey = `${moduleId}-${sessionId}`;
            newCompletedSessions.add(sessionKey);
            setCompletedSessions(newCompletedSessions);

            // Check if all sessions in the module are completed
            const currentModuleSessions = courseData.modules[moduleId].sessions;
            const allSessionsCompleted = currentModuleSessions.every((_, index) => 
                newCompletedSessions.has(`${moduleId}-${index}`)
            );

            if (allSessionsCompleted) {
                markModuleComplete(moduleId);
            } else {
                // Move to next session
                if (sessionId < currentModuleSessions.length - 1) {
                    setCurrentSession(sessionId + 1);
                }
            }

            // Update progress in backend
            await courseApi.updateProgress({
                courseId,
                moduleId,
                sessionId,
                completed: true
            });

        } catch (error) {
            showError('Failed to update progress');
        }
    };

    // Fetch course data and enrollment status
    // useEffect(() => {
    //     const fetchCourseData = async () => {
    //         try {
    //             setLoading(true);
    //             const response = await courseApi.getCourse(courseId);
    //             setCourseData(response.data);
                
    //             if (isAuthenticated) {
    //                 const enrollmentStatus = await courseApi.checkEnrollment(courseId);
    //                 setIsEnrolled(enrollmentStatus.data.isEnrolled);
    //                 setProgress(enrollmentStatus.data.progress || 0);
    //             }
    //         } catch (error) {
    //             setError(error.response?.data?.message || 'Failed to load course');
    //             showError(error.response?.data?.message || 'Failed to load course');
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     if (!courseId) {
    //         navigate('/learning');
    //         return;
    //     }

    //     fetchCourseData();
    // }, [courseId, isAuthenticated]);

    const courseData = {
    title: "Best Management Practices in Aquaculture",
    description: "Master the essential practices for successful aquaculture management",
    duration: "1 min",
    modules: [
        {
            id: 1,
            title: "Introduction to Aquaculture Management",
            sessions: [
                {
                    id: "1.1",
                    title: "Overview of Aquaculture Systems",
                    duration: "45 mins",
                    videoUrl: "https://www.youtube.com/watch?v=apqXWvaGmow",
                    notes: "https://drive.google.com/file/d/194J70lZxDcn8Scvl210Idoz6c9j8FVnC/view",
                    isCompleted: false
                },
                // More sessions...
            ]
        },
        // More modules...
    ]
};

    // Authentication check
    // useEffect(() => {
    //     if (!isAuthenticated) {
    //         navigate('/login', { 
    //             state: { 
    //                 returnUrl: `/learning/course/${courseId}`,
    //                 message: 'Please login to access this course' 
    //             } 
    //         });
    //     }
    // }, [isAuthenticated]);

    const handleEnrollment = async () => {
        try {
            setLoading(true);
            await courseApi.enrollInCourse(courseId);
            setIsEnrolled(true);
            showSuccess('Successfully enrolled in the course!');
        } catch (error) {
            showError(error.response?.data?.message || 'Failed to enroll in course');
        } finally {
            setLoading(false);
        }
    };

    // const handleSessionComplete = async (moduleId, sessionId) => {
    //     try {
    //         const response = await courseApi.updateProgress({
    //             courseId,
    //             moduleId,
    //             sessionId,
    //             completed: true
    //         });

    //         setProgress(response.data.progress);

    //         if (response.data.progress === 100) {
    //             showSuccess('Congratulations! You\'ve completed the course!');
    //             navigate('/certificate');
    //         }
    //     } catch (error) {
    //         showError('Failed to update progress');
    //     }
    // };

    if (loading) {
        return <LoadingSpinner />;
    }

    if (error) {
        return (
            <div className="error-container">
                <h2>Something went wrong</h2>
                <p>{error}</p>
                <button onClick={() => navigate('/learning')}>
                    Return to Courses
                </button>
            </div>
        );
    }

    if (!courseData) {
        return null;
    }

    return (
        <div className="course-page">
            <div className="course-hero">
                <h1>{courseData.title}</h1>
                <p>{courseData.description}</p>
                {isEnrolled ? (
                    <ProgressTracker 
                        progress={progress} 
                        totalDuration={courseData.duration} 
                    />
                ) : !isAuthenticated ? (
                    <button 
                        className="login-button"
                        onClick={() => navigate('/login', { 
                            state: { 
                                returnUrl: `/learning/course/${courseId}`,
                                message: 'Please login to access this course' 
                            } 
                        })}
                    >
                        Login to Access Course
                    </button>
                ) : (
                    <button 
                        className="enroll-button"
                        onClick={handleEnrollment}
                        disabled={loading}
                    >
                        {loading ? 'Enrolling...' : 'Enroll Now'}
                    </button>
                )}
            </div>

            {isEnrolled && (
                <div className="learning-container">
                    <aside className="module-sidebar">
                        <ModuleList 
                            modules={courseData.modules}
                            currentModule={currentModule}
                            currentSession={currentSession}
                            completedModules={completedModules}
                        completedSessions={completedSessions}
                        onSessionSelect={(moduleId, sessionId) => {
                            setCurrentModule(moduleId);
                            setCurrentSession(sessionId);
                        }}
                        />
                    </aside>

                    <main className="learning-content">
                        <VideoPlayer 
                            url={courseData.modules[currentModule].sessions[currentSession].videoUrl}
                            onComplete={() => handleSessionComplete(currentModule, currentSession)}
                        />
                        <Notes 
                            content={courseData.modules[currentModule].sessions[currentSession].notes}
                        />
                    </main>
                </div>
             )}
        </div>
    );
};

export default CoursePage;